(ns ductile.util
  (:require [clojure.string :as str])
  (:require-macros ductile.util))

(defn distinct-by
  "Returns a lazy sequence of the elements of coll with duplicates,
  determined by (f item), removed. If (f item) produces the same
  result for multiple items, only the first item will be retained.
  Returns a stateful transducer when no collection is provided.

  from https://clojure.atlassian.net/browse/CLJ-2658"
  {:static true}
  ([f]
   (fn [rf]
     (let [seen (volatile! #{})]
       (fn
         ([] (rf))
         ([result] (rf result))
         ([result input]
          (let [finput (f input)]
            (if (contains? @seen finput)
              result
              (do (vswap! seen conj finput)
                  (rf result input)))))))))
  ([f coll]
   (let [step (fn step [xs seen]
                (lazy-seq
                 ((fn [[head :as xs] seen]
                    (when-let [s (seq xs)]
                      (let [fhead (f head)]
                        (if (contains? seen fhead)
                          (recur (rest s) seen)
                          (cons head (step (rest s) (conj seen fhead)))))))
                  xs seen)))]
     (step coll #{}))))


(defn format-amount [amount currency]
  (when amount
    (condp = currency
      :currency/euro
      (.toLocaleString (/ amount 100) "de-DE" #js {:style "currency" :currency "EUR"})
      :currency/plain
      (.toLocaleString (/ amount 100) "de-DE" #js {:minimumFractionDigits 2 :maximumFractionDigits 2})
      :currency/dollar
      (.toLocaleString (/ amount 100) "en-US" #js {:style "currency" :currency "USD"})
      (str (/ amount 100) " ?"))))

(defn has-service? [fahrzeug service-code]
  (or
   (some #(= service-code (:service/code %)) (:service.event/completed fahrzeug))
   (some #(= service-code %) (:workflow/open-service-codes fahrzeug))))

(defn dissoc-blanks-vals
  "Remove map values that are `nil?` or `string?` and blank."
  [m]
  (into (empty m)
        (remove #(or (nil? (val %))
                     (and (string? (val %))
                          (str/blank? (val %)))))
        m))
